import { createStore, applyMiddleware } from "redux"
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly"

import callApi from "./middleware/callApi"
import rootReducer from "./modules/reducers"

export default function configureStore(initialState) {
	const middleware = [callApi]
	const store = createStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(...middleware)))
	return store
}
